import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setFiles, setPartnerProfileImages } from "../shared/sharedSlice";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const GET_ALL_USER = `${API_URL}/users/getAllUsers`;
const ADD_USER_DETAILS = `${API_URL}/users`;
const UPDATE_USER_DETAILS = `${API_URL}/users/`;
const APPROVE_USER = `${API_URL}/users/approve/`;
const VERIFY_PARTNER = `${API_URL}/verifyPartnerByAdmin`;
const COMMON_FILE_UPLOAD = `${API_URL}/fileUpload`;
const USERS_URL = `${API_URL}/users`

export const clearUserState = () => ({
  type: 'userList/clearState'
});

export const getUsers = createAsyncThunk(
  "getUsers",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);

      const { page, limit, search = '', account = '' } = values
      const { data } = await axios.get(`${GET_ALL_USER}?page=${page}&limit=${limit}&search=${search}&account=${account}`, {headers: {authorization: user.token}});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const getAllDealers = createAsyncThunk(
  "getAllDealers",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      
      const { data } = await axios.get(`${USERS_URL}/get/allDealers`, {headers: {authorization: user.token}});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const verifyPartner = createAsyncThunk(
  "verifyPartner",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { id, verifiedStatus } = values
      const { data } = await axios.patch(`${VERIFY_PARTNER}/${id}`, { verifiedStatus: verifiedStatus });
      // notify(data.responseMessage, 'success');
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const commonFileUpload = createAsyncThunk(
  "commonFileUpload",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios({
        method: "post",
        url: `${COMMON_FILE_UPLOAD}`,
        data: values,
        headers: { "Content-Type": "multipart/form-data" },
      })
      dispatch(setFiles(data))
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const partnerProfileImage = createAsyncThunk(
  "commonFileUpload",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios({
        method: "post",
        url: `${COMMON_FILE_UPLOAD}`,
        data: values,
        headers: { "Content-Type": "multipart/form-data" },
      })
      dispatch(setPartnerProfileImages(data))
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateUserDetails = createAsyncThunk(
  "updateUserDetails",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      let selectedPage = values.get("selectedPage")
      const { data } = await axios.put(`${UPDATE_USER_DETAILS}${values.get("id")}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getUsers({page: selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const approveUser = createAsyncThunk(
  "approveUser",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      const { data } = await axios.put(`${APPROVE_USER}${values.id}`, values);
      notify(data.responseMessage, 'success'); 
      dispatch(getUsers({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addUserDetails = createAsyncThunk(
  "addUserDetails",
  async (values: any, { rejectWithValue }) => {
    try {
      let user: any = localStorage.getItem("kt-auth-react-v");
      user = JSON.parse(user);

      const { data } = await axios.post(
        ADD_USER_DETAILS,
        values,
        { headers: { authorization: user.token } }
      );

      // ✅ IMPORTANT CONDITION
      if (data?.data?.code !== 0) {
        return rejectWithValue({
          responseMessage: data?.data?.message || "Operation failed",
          code: data?.data?.code,
        });
      }


      return data; // success

    } catch (error: any) {
      return rejectWithValue({
        responseMessage:
          error.response?.data?.responseMessage || "Something went wrong",
      });
    }
  }
);



export const deleteUser = createAsyncThunk(
  "deleteUser",
  async (values: any, { rejectWithValue, dispatch }) => { 
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);

      const { data } = await axios.delete(`${UPDATE_USER_DETAILS}${values.id}`, {headers: {authorization: user.token}});
      console.log('data', data);
       // ✅ IMPORTANT CONDITION
       if (data?.data?.code !== 0) {
        notify(data?.data?.message || "Operation failed", 'error'); 
        return rejectWithValue({
          responseMessage: data?.data?.message || "Operation failed",
          code: data?.data?.code,
        });
      }

      notify(data.responseMessage, 'success'); 
      dispatch(getUsers({page: values.selectedPage || 1, limit:10}));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const assignMemberToTrainer=createAsyncThunk(
  "assignMembersToTrainer",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      // let selectedPage = values.get("selectedPage")

     console.error('pvalue isss@@@!!!dfsdfsfd',values)
      const { data } = await axios.put(`${UPDATE_USER_DETAILS}trainer/${values.trainer}/assignedMembers`, values.participants);
      notify(data.responseMessage, 'success');
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
)
